import { LabelGroup as PrimerLabelGroup, LabelGroupProps as PrimerLabelGroupProps } from '@primer/react';
import { PropsWithChildren } from 'react';

type Props = {} & PrimerLabelGroupProps;

const LabelGroup = ({ ...props }: PropsWithChildren<Props>) => <PrimerLabelGroup {...props} />;

export default LabelGroup;
export type { Props as LabelGroupProps };
